import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { MessageMaintenanceService } from '../services/message-maintenance.service';

export const messageMaintenanceGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const messageMaintenanceService = inject(MessageMaintenanceService);
  const router = inject(Router);

  if (authService.user?.role?.slug == 'super-admin') {
    return true;
  }

  messageMaintenanceService.pullList().subscribe({
    next: (messageMaintenanceList) => {
      if (messageMaintenanceList.length > 0) {
        router.navigateByUrl('/maintenance');
      }
    }
  });

  return true;
};
